import getSettings from './jsonGeneratingFunctions/jsonGetSettings';
import getDefSites from './jsonGeneratingFunctions/jsonGetDefSites';
import getPlugins from './jsonGeneratingFunctions/jsonGetPlugins';
import getTemplates from './jsonGeneratingFunctions/jsonGetTemplates';
import getBanners from './jsonGeneratingFunctions/jsonGetBanners';
import getTranslations from './jsonGeneratingFunctions/jsonGetTranslations';

function generateJSON() {
    const js = {};
    js.Sites = getDefSites();
    js.Plugins = getPlugins.call(this);
    js.Templates = getTemplates.call(this);
    js.Banners = getBanners.call(this);
    js.translations = getTranslations.call(this);
    js.Liquid = getSettings.call(this);

    return js;
}

export default generateJSON;